import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  cityCount: 4, // Default fallback values
  storeCount: 6,
  customerCount: 10000,
  isLoading: false,
  error: null,
};

const statsSlice = createSlice({
  name: 'stats',
  initialState,
  reducers: {
    setStats: (state, action) => {
      console.log('setStats reducer called with payload:', action.payload);
      const { cityCount, storeCount, customerCount } = action.payload;
      console.log('Extracted values:', { cityCount, storeCount, customerCount });
      state.cityCount = cityCount;
      state.storeCount = storeCount;
      state.customerCount = customerCount;
      state.isLoading = false;
      state.error = null;
      console.log('Updated state:', state);
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    resetStats: (state) => {
      state.cityCount = 4;
      state.storeCount = 6;
      state.customerCount = 10000;
      state.isLoading = false;
      state.error = null;
    },
  },
});

export const { setStats, setLoading, setError, resetStats } = statsSlice.actions;
export default statsSlice.reducer;